import { SignInButton, SignUpButton } from '@clerk/nextjs';
import { RequestAccessDrawer } from '@components/landing/RequestAccessDrawer';
import { Button } from '@components/ui/button';
import { getHref, ROUTE } from '@utils/route-utils';
import { ArrowRight } from 'lucide-react';
import { FC } from 'react';

type SignUpCTAProps = {
  organizationId?: string | undefined;
  variant?: 'full' | 'sign-in-only' | 'sign-up-only';
  signUpLabel?: string;
  signInLabel?: string;
  renderArrow?: boolean;
  inviteOnlyLogin?: boolean;
};

const SignUpCTA: FC<SignUpCTAProps> = ({
  organizationId,
  variant = 'full',
  signUpLabel = 'Sign up',
  signInLabel = 'Log in',
  renderArrow = false,
  inviteOnlyLogin = false
}) => {
  const redirectUrl = getHref(organizationId, [ROUTE.HOME]);

  const Btn = (text: string, variant: 'default' | 'outline' = 'default') => (
    <Button variant={variant}>
      {text}
      {renderArrow && <ArrowRight className="w-5 h-5 ml-2" />}
    </Button>
  );

  const signUpBtn = (text: string) => (
    <SignUpButton
      signInForceRedirectUrl={ROUTE.ONBOARDING}
      signInFallbackRedirectUrl={redirectUrl}
    >
      {Btn(text)}
    </SignUpButton>
  );

  const signInBtn = (text: string) => (
    <SignInButton
      forceRedirectUrl={redirectUrl}
      fallbackRedirectUrl={redirectUrl}
      signUpFallbackRedirectUrl={redirectUrl}
      signUpForceRedirectUrl={redirectUrl}
    >
      {Btn(text, 'outline')}
    </SignInButton>
  );

  const clerkButtons = (
    <div className="flex gap-4 md:order-2">
      {variant === 'full' && (
        <>
          {signInBtn(signInLabel)}
          {signUpBtn(signUpLabel)}
        </>
      )}
      {variant === 'sign-in-only' && signInBtn(signInLabel)}
      {variant === 'sign-up-only' && signUpBtn(signUpLabel)}
    </div>
  );

  const requestBetaAccess = <RequestAccessDrawer />;

  return <div>{inviteOnlyLogin ? requestBetaAccess : clerkButtons}</div>;
};

export default SignUpCTA;
